import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { Observable, filter, switchMap } from 'rxjs';
import { IdentityStore, IdentityStoreType } from 'src/app/app-state/identity/identity.store';

export class AskookTranslateLoader implements TranslateLoader {
  private identityStore: IdentityStoreType = inject(IdentityStore);
  private http: HttpClient = inject(HttpClient);

  isAuthenticated$ = toObservable(this.identityStore.isAuthenticated);

  getTranslation(lang: string): Observable<any> {
    return this.isAuthenticated$.pipe(
      filter(isAuthenticated => isAuthenticated),
      switchMap(() =>
        this.http.get<any>(
          `${environment.highlanderBffUrl}/gateway/umbraco/translations/GetForLocaleNormalized/?baseKey=partner&lang=en-us`,
        ),
      ),
    );
  }
}

export class AskookMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    if (environment.showMissingTranslations) {
      // eslint-disable-next-line no-console
      console.info(`Missing ${params.key} translations`);
      return `!${params.key}!`;
    } else {
      return '';
    }
  }
}

export const translationsRootConfig: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useClass: AskookTranslateLoader,
    deps: [HttpClient, Store],
  },
  missingTranslationHandler: {
    provide: MissingTranslationHandler,
    useClass: AskookMissingTranslationHandler,
  },
  useDefaultLang: true,
  defaultLanguage: 'en',
};
